import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  styled,
  Typography,
} from "@mui/material";
import { QuickSelection, SelectedMode, SelectionOptions } from "../constant";
import useHomeStore from "../../../../../stores/useHomeStore";
import { KeyboardArrowDown } from "@mui/icons-material";
import { useState } from "react";

const CustomContainer = styled(Box)({
  flex: 1,
  display: "flex",
  flexDirection: "column",
  gap: "28px",
});

const ModeSelectionWrapper = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: "12px",
});

const ModeSelectionItem = styled(Box)(({ isActive }) => ({
  display: "flex",
  alignItems: "center",
  gap: "16px",
  padding: "16px",
  borderRadius: "15px",
  color: "#757575",
  backgroundColor: "#FFFFFF",
  fontWeight: 400,
  cursor: "pointer",
  ...(isActive && {
    color: "#FFFFFF",
    backgroundColor: "#FB4764",
  }),
}));

const QuickSelectionWrapper = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: "12px",
});

export const CustomAccordion = styled(Accordion)({
  boxShadow: "none",
  border: "1px solid #d9d9d9",
  borderRadius: "16px",
  backgroundColor: "#f5f5f5",
  fontWeight: 400,
  color: "#757575",

  "&::before": {
    display: "none",
  },

  "&:first-of-type": {
    borderTopLeftRadius: "16px",
    borderTopRightRadius: "16px",
  },

  "&:last-of-type": {
    borderRadius: "16px",
  },

  "&.Mui-expanded": {
    margin: 0,
  },
});

const CustomAccordionSummary = styled(AccordionSummary)({
  height: "48px",
  backgroundColor: "#ffffff",
  borderTopLeftRadius: "16px",
  borderTopRightRadius: "16px",
  borderBottomLeftRadius: "16px",
  borderBottomRightRadius: "16px",

  "&.Mui-expanded": {
    minHeight: "0",
    border: "1px solid #d9d9d9",
    borderTop: "0",
    borderLeft: "0",
    borderRight: "0",
    borderBottomLeftRadius: "16px",
    borderBottomRightRadius: "16px",
  },

  "& .MuiAccordionSummary-content.Mui-expanded": {
    margin: "12px 0",
  },
});

const CustomAccordionDetails = styled(AccordionDetails)({
  display: "flex",
  flexDirection: "column",
  gap: "10px",
});

const Chips = styled(Box)({
  display: "inline",
  fontSize: "13px",
  fontWeight: 400,
  color: "#757575",
  padding: "6px 12px",
  backgroundColor: "#ffffff",
  borderRadius: "14px",
  cursor: "pointer",
  border: "1px solid #d9d9d9",
});

const SideController = () => {
  const {
    selectedMode,

    setSelectedMode,
    setPreviousCreateImagePrompt,
    setOriginalPrompt,
  } = useHomeStore();

  const [expandedAccordion, setExpandedAccordion] = useState(false);

  const handleAccordionChange = (panel) => (event, isExpanded) => {
    setExpandedAccordion(isExpanded ? panel : false);
  };

  const isCreateImage = selectedMode === SelectedMode.CreateImage;

  return (
    <CustomContainer>
      <ModeSelectionWrapper>
        {SelectionOptions.map(({ label, value }, index) => (
          <ModeSelectionItem
            key={index}
            isActive={selectedMode === value}
            onClick={() => setSelectedMode(value)}
          >
            {label}
          </ModeSelectionItem>
        ))}
      </ModeSelectionWrapper>

      {isCreateImage && (
        <QuickSelectionWrapper>
          <Typography color="#757575" fontWeight={400} fontSize={18}>
            Quick Inspirations
          </Typography>

          {QuickSelection.map(({ label, value }, index) => (
            <CustomAccordion
              key={index}
              expanded={expandedAccordion === label}
              onChange={handleAccordionChange(label)}
            >
              <CustomAccordionSummary
                expandIcon={<KeyboardArrowDown />}
                sx={{
                  "& .MuiAccordionSummary-expandIconWrapper": {
                    color: "#757575",
                  },
                }}
              >
                {label}
              </CustomAccordionSummary>

              <CustomAccordionDetails>
                {value.map((item, index) => (
                  <Box
                    key={index}
                    sx={{ display: "flex", gap: "10px" }}
                    onClick={() => {
                      setPreviousCreateImagePrompt(item.value);
                      setOriginalPrompt(item.value);
                    }}
                  >
                    <Chips>{item.label}</Chips>
                  </Box>
                ))}
              </CustomAccordionDetails>
            </CustomAccordion>
          ))}
        </QuickSelectionWrapper>
      )}
    </CustomContainer>
  );
};

export default SideController;
